<template>
	<div class='root'>
		<MeetingHeader/>
		<div class="container">
			<div class="search">
				<Select class='sh-select' placeholder='请选择生活馆' size='large' v-model="store">
			        <Option v-for="item in storeList" :value="item.StoreId" :key="item.StoreId">{{ item.StoreName }}</Option>
			    </Select>
			    <Button @click='go2List' type='primary' size='large' class='button'>查询</Button>
			</div>
		</div>
		<div class="rule">
			<p>{{ rule.title }}</p>
			<p v-for="(text,i) in rule.text" :key="i">{{ text }}</p>
			<p class="bottomText">多特瑞中国</p>
		</div>
		<Modal v-model='showAgreement' :mask-closable='false'>
			<div slot='header'><div class="header">{{content.Title}}</div></div>
			<div class="body">
				<div v-html='content.Content'></div>
			</div>
			<div slot='footer'>
				<div class='modal-footer'>
					<Checkbox v-model="agree">我已阅读，并同意以上规则</Checkbox>
					<Button :disabled='!agree' class='btn' type='primary' long @click='goNext'>下一步</Button>	
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				store:'',
				storeList:[],
				showAgreement:false,
				agree:false,
				content:{},
				rule:{
					title:'会议室使用规范',
					text:[
						'1. 会议室内禁止摄影摄像；',
						'2. 会议室内禁止举办带有收费性质的课程或沙龙；',
						'3. 保持室内环境，请勿携带气味强烈的食品、饮料等在会议室内食用；',
						'4. 爱护会议室内设备，若发生设备损坏或遗失，需按设备价格由会议负责人进行赔偿；',
						'5. 会议室使用时间请按照申请时段举行，适当提醒切勿超时，以免影响后续使用；',
						'6. 会议室仅供顾客聊天、产品分享、产品体验等与精油相关事宜，禁止脱衣及大面积裸露皮肤的芳香调理。',
						'7. 生活馆员工会对预约使用会议室的老师课件PPT进行提前审核，主要针对夸大宣传和涉医涉传等敏感信息的规避，也请大家知晓。',
					]
				}
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[],
		components: {
			MeetingHeader,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getStoresAction',
				'getTipDetailAction',
			]),
			async initData(){
				let response = await this.getStoresAction()
				this.storeList = response || []
				this.content = await this.getTipDetailAction('Meeting_Fee_Agree')
			},
			goNext(){
				this.$router.push({
					path:'/meeting/home',
					query:{
						storeId:this.store
					}
				})
			},
			go2List(){
				if (this.store) {
					this.showAgreement = true
				}
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1.5rem;
		margin:0 auto;
		display:block;
	}
	.rule{
		margin: 0 24vw;
		line-height: 40px;
		font-size: 16px;
		p:first-child{
			margin: 0.8rem 0 0.2rem 0;
			font-size: 24px;
			text-align: center;
		}
		.bottomText{
			text-align: right;
			padding: 30px 0 20px 0;
		}
	}
	.search {
		display:flex;
	}
	.sh-select {
		width:320px;
	}
	.button {
		width:160px;
		margin-left:10px;
		border-radius:20px;
	}
	.header {
		text-align: center;
	}
	.modal-footer {
		display:flex;
		flex-direction: column;
		align-items: center;
		.btn {
			margin-top: 10px;
		}
	}
	@media (max-width: 768px){
		.container {
			padding-top:3rem;
		}
		.button {
			margin-left:0px;
			margin-top: 20px;
			width:200px;
		}
		.search {
			flex-direction: column;
			align-items: center;
		}
		.rule{
			margin: 0 10px 0 20px;
			line-height: 38px;
			font-size: 14px;
			p:first-child{
				font-size: 22px;
				margin: 40px 0 20px 0;
			}
		}
	}
</style>